import {
    useCreatePersonaMutation,
    useDeletePersonaMutation,
    usePersonaQuery,
    useUpdatePersonaMutation,
} from './usePersonasQuery';
import {PersonaFormValues} from '../types';

export const usePersona = (personaId?: string) => {
    const {
        data: record,
        isLoading: loading,
        refetch: fetchRecord
    } = usePersonaQuery(personaId || '');

    const createMutation = useCreatePersonaMutation();
    const updateMutation = useUpdatePersonaMutation();
    const deleteMutation = useDeletePersonaMutation();

    const createRecord = async (values: PersonaFormValues) => {
        return await createMutation.mutateAsync(values);
    };

    const updateRecord = async (values: PersonaFormValues) => {
        if (typeof personaId === 'undefined') {
            throw new Error('personaId is required parameter');
        }
        return await updateMutation.mutateAsync({
                                                    id: personaId,
                                                    record: values,
                                                });
    };

    const deleteRecord = async () => {
        if (typeof personaId === 'undefined') {
            throw new Error('personaId is required parameter');
        }
        return await deleteMutation.mutateAsync(personaId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
